/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { TouchplanPlatform } from './touchplan-platforms.enum';

/**
 * Platform configuration lives here.
 * In mobile and desktop's `app.module` files, a provider is declared that looks something like:
 * `{ provide: PlatformConfiguration, useClass: PlatformMobileConfiguration }`
 * This means that while on either platform you inject the base service (this file) and you recieve the platform specific one via
 * dependency injection magic.
 *
 * The general intent is that the platform string is rarely if every used, and instead specific configurations for specific things are
 * placed directly into this file. Best practices still state that this service should not be injected into shared modules, but passed in as inputs.
 */
@Injectable()
export abstract class PlatformConfiguration {
	public abstract readonly platform: TouchplanPlatform;
	public abstract readonly refreshNowNagPath: string;
}
